import $ from 'jquery';

angular.module("SupportAgent")
.controller(
 'TabmdmController',
 ['$rootScope', '$scope',
 function ($rootScope, $scope) {
  $scope.refreshMDM = function() {
   $('#mdmrefreshicon').addClass('fa-spin');
   $rootScope.fetchMDMdetails();
  };
 }]);
